import PropTypes from 'prop-types';
import React from 'react';
import { StyledTab, StyledTabLabel } from './styled-tabs';

const propTypes = {
	activeTab: PropTypes.bool.isRequired,
	label: PropTypes.string.isRequired,
};

function Tab({ activeTab, label, ...props }) {
	return (
		<StyledTab className={activeTab ? 'active' : ''} {...props}>
			<StyledTabLabel
				size="m1"
				tag="p"
				type="paragraph"
				color="var(--color-global-grey1000)"
				title={label}
			>
				{label}
			</StyledTabLabel>
		</StyledTab>
	);
}

Tab.propTypes = propTypes;

export default Tab;
